/* ZANYA Theme Two behaviours: concern tabs, menu segments, pinned steps, results
   slider, collection views, treatment anchors, floating Book pill. No dependencies. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* generic tab groups: [data-tabs] holds buttons [data-tab=key]; panels [data-panel=key] */
  function initTabs(root) {
    var btns = root.querySelectorAll('[data-tab]');
    var panels = root.querySelectorAll('[data-panel]');
    if (!btns.length) return;
    function show(key) {
      btns.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === key ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
      panels.forEach(function (p) { if (!p.hidden) p.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); }); });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-tab')); }); });
    show(btns[0].getAttribute('data-tab'));
  }

  /* pinned steps: highlight the step nearest the viewport centre and swap the image */
  function initSteps(root) {
    var items = root.querySelectorAll('[data-step]');
    var frames = root.querySelectorAll('[data-step-img]');
    var list = root.querySelector('ol');
    if (!items.length) return;
    var current = -1;
    function set(i) {
      if (i === current) return; current = i;
      items.forEach(function (li, k) { li.classList.toggle('on', k === i); });
      frames.forEach(function (f, k) { f.classList.toggle('on', k === i); });
      if (list) list.style.setProperty('--fill', ((i + 1) / items.length * 100) + '%');
    }
    if (window.innerWidth <= 920) { set(0); return; }
    var ticking = false;
    function frame() {
      ticking = false;
      var mid = window.innerHeight * 0.5; var best = 0; var bestD = Infinity;
      var src = frames.length === items.length ? frames : items;
      src.forEach(function (el, k) {
        var r = el.getBoundingClientRect(); var d = Math.abs(r.top + r.height / 2 - mid);
        if (d < bestD) { bestD = d; best = k; }
      });
      set(best);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }

  /* before and after slider */
  function initBA(el) {
    var range = el.querySelector('input[type="range"]');
    if (!range) return;
    function upd() { el.style.setProperty('--x', range.value + '%'); }
    range.addEventListener('input', upd); upd();
  }

  /* collection views: grid, list, compare. Remembered per browser. */
  function initViews(root) {
    var btns = root.querySelectorAll('[data-view]');
    var panels = root.querySelectorAll('[data-view-panel]');
    if (!btns.length) return;
    var key = 'zn2-view';
    function show(v) {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === v ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-view-panel') !== v; });
      panels.forEach(function (p) { if (!p.hidden) p.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); }); });
      try { localStorage.setItem(key, v); } catch (e) {}
    }
    var saved = null; try { saved = localStorage.getItem(key); } catch (e) {}
    var valid = Array.prototype.map.call(btns, function (b) { return b.getAttribute('data-view'); });
    show(saved && valid.indexOf(saved) > -1 ? saved : root.getAttribute('data-default-view') || valid[0]);
    btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-view')); }); });
  }

  /* treatment page anchors: mark the section in view */
  function initAnchors(nav) {
    var links = nav.querySelectorAll('a[href^="#"]');
    var targets = Array.prototype.map.call(links, function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    if (!links.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var i = targets.indexOf(en.target);
          links.forEach(function (a, k) { a.classList.toggle('on', k === i); });
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });
    targets.forEach(function (t) { if (t) io.observe(t); });
  }

  /* floating Book pill on desktop once the first screen has passed */
  function initFloat() {
    var el = document.querySelector('[data-float-book]');
    if (!el) return;
    var ticking = false;
    function frame() {
      ticking = false;
      var on = window.scrollY > window.innerHeight * 0.8 && window.innerWidth > 920;
      el.classList.toggle('on', on);
      document.body.classList.toggle('has-float', on);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    window.addEventListener('resize', frame);
    frame();
  }

  function init() {
    document.querySelectorAll('[data-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-steps]').forEach(initSteps);
    document.querySelectorAll('[data-ba]').forEach(initBA);
    document.querySelectorAll('[data-views]').forEach(initViews);
    document.querySelectorAll('[data-anchors]').forEach(initAnchors);
    initFloat();
    /* theme two has no hidden resting state: anything still unrevealed after load shows */
    setTimeout(function () { document.querySelectorAll('.io').forEach(function (s) { var r = s.getBoundingClientRect(); if (r.top < window.innerHeight) s.classList.add('in'); }); }, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
